import React, { useState, useContext } from "react";
import { SearchContext } from "../providers/SearchProvider";
import { DateContext } from "../providers/DateProvider";
import { CategoryContext } from "../providers/CategoryProvider";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

// ---------- helpers (dayKey-first) ----------
const pad2 = (n) => String(n).padStart(2, "0");

const startOfLocalDay = (dateLike) => {
  const d = dateLike instanceof Date ? new Date(dateLike) : new Date(dateLike);
  d.setHours(0, 0, 0, 0);
  return d;
};

const toDayKey = (dateLike) => {
  const d = startOfLocalDay(dateLike);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

const dayKeyToLocalDate = (dayKey) => {
  if (!dayKey || typeof dayKey !== "string") return null;
  const [y, m, d] = dayKey.split("-").map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  dt.setHours(0, 0, 0, 0);
  return dt;
};

const formatDayKeyMMDDYYYY = (dayKey) => {
  const d = dayKeyToLocalDate(dayKey);
  if (!d) return "";
  const mm = pad2(d.getMonth() + 1);
  const dd = pad2(d.getDate());
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

function SearchedLocationListItem(props) {
  const [hover, setHover] = useState(false);
  const { setSearchFocused, setSearchText, setPreventBlur } =
    useContext(SearchContext);

  // NEW provider API
  const { setSelectedDate } = useContext(DateContext);
  const { setCategory } = useContext(CategoryContext);

  const handleMouseEnter = () => {
    setPreventBlur(true);
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  const flexRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid gray",
    padding: 8,
    backgroundColor: hover ? "rgba(0, 0, 0, 0.3)" : "transparent",
  };

  const flexCol = {
    marginRight: 10,
    fontSize: props.isSmall ? 10 : "small",
  };

  const rowMobile = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderBottom: "1px solid gray",
    padding: 8,
    backgroundColor: hover ? "rgba(0, 0, 0, 0.3)" : "transparent",
  };

  // Prefer dayKey-first, fall back to legacy group startDate/day
  const dayKey =
    props.location?.dayKey ??
    props.location?.groupDayKey ??
    props.location?.groupStartDay ??
    (props.location?.startDate != null ? toDayKey(new Date(props.location.startDate)) : null) ??
    (props.location?.day ? toDayKey(new Date(props.location.day)) : null);

  const prettyDate = dayKey ? formatDayKeyMMDDYYYY(dayKey) : "";

  const handleOnClick = () => {
    if (dayKey) {
      // provider normalizes anyway, but we pass a local-midnight Date
      const clicked = dayKeyToLocalDate(dayKey);
      if (clicked) setSelectedDate(clicked);
    }

    setCategory(props.location?.category);
    setSearchFocused(false);
    setSearchText("");
  };

  return (
    <>
      {!props.isXs && (
        <li
          style={{ ...flexRow, color: "lightGray", cursor: "pointer" }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleOnClick}
        >
          <div style={{ ...flexCol, width: "200px" }}>
            {props.location?.type}{" "}
            {props.location?.setName ? "- " + props.location.setName : ""}
          </div>

          <div style={{ ...flexCol, width: "200px" }}>
            {props.location?.name}
          </div>

          <div style={{ ...flexCol, width: "200px" }}>
            <FiberManualRecordIcon
              style={{ fontSize: "10px", color: props.location?.groupColor }}
            />{" "}
            {props.location?.groupName}
          </div>

          <div style={{ ...flexCol, width: "400px" }}>
            {props.location?.mapData?.address}
          </div>

          <div style={{ ...flexCol, width: "100px" }}>
            {props.location?.category}
          </div>

          <div style={{ ...flexCol, width: "150px" }}>{prettyDate}</div>
        </li>
      )}

      {props.isXs && (
        <div
          style={{ ...rowMobile, cursor: "pointer" }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleOnClick}
        >
          <div>
            <span style={{ color: "white", fontSize: 11 }}>NAME:</span>{" "}
            {props.location?.name}
          </div>

          <div>
            <span style={{ color: "white", fontSize: 11 }}>TYPE:</span>{" "}
            {props.location?.type}{" "}
            {props.location?.setName ? "- " + props.location.setName : ""}
          </div>

          <div>
            <span style={{ color: "white", fontSize: 11 }}>GROUP:</span>{" "}
            {props.location?.groupName}{" "}
            <FiberManualRecordIcon
              style={{ fontSize: "10px", color: props.location?.groupColor }}
            />
          </div>

          <div>
            <span style={{ color: "white", fontSize: 11 }}>ADDRESS:</span>{" "}
            {props.location?.mapData?.address}
          </div>

          <div>
            <span style={{ color: "white", fontSize: 11 }}>CATEGORY:</span>{" "}
            {props.location?.category}
          </div>

          <div>
            <span style={{ color: "white", fontSize: 11 }}>DATE:</span>{" "}
            {prettyDate}
          </div>
        </div>
      )}
    </>
  );
}

export default SearchedLocationListItem;